import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import { FaMapMarkerAlt, FaPhone, FaEnvelope, FaWhatsapp } from 'react-icons/fa';

const ContactContainer = styled.div`
  padding: 100px 0;
  background: #f5f5f5;
`;

const ContactWrapper = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 50px;
  padding: 0 50px;

  @media screen and (max-width: 768px) {
    grid-template-columns: 1fr;
    padding: 0 20px;
    grid-gap: 0px;
  }
`;

const ContactInfo = styled.div`
  display: flex;
  flex-direction: column;
`;

const ContactTitle = styled.h2`
  font-size: 2.5rem;
  color: #1A365D;
  margin-bottom: 30px;
  font-family: 'Playfair Display', serif;

  @media screen and (max-width: 480px) {
    font-size: 2rem;
  }
`;

const ContactSubtitle = styled.p`
  font-size: 18px;
  line-height: 1.5;
  margin-bottom: 30px;
  font-family: 'Open Sans', sans-serif;
  color: #333;
`;

const Row = styled.div`
  display: flex;
  flex-rirection: row;
  width: 100%
`;

const ContactItem = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  margin-bottom: 20px;
`;

const ContactIcon = styled.div`
  margin-right: 15px;
  font-size: 24px;
  color: #4CAF50;
`;

const ContactText = styled.p`
  font-size: 16px;
  font-family: 'Open Sans', sans-serif;
  color: #333;
`;

const MapContainer = styled.div`
  width: 100%;
  height: 300px;
  margin-top: 30px;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
`;

const FormContainer = styled(motion.div)`
  background: #fff;
  padding: 40px;
  border-radius: 10px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
`;

const FormTitle = styled.h3`
  font-size: 1.5rem;
  color: #1A365D;
  margin-bottom: 20px;
  font-family: 'Playfair Display', serif;
`;

const FormGroup = styled.div`
  margin-bottom: 20px;
`;

const FormLabel = styled.label`
  display: block;
  margin-bottom: 8px;
  font-size: 14px;
  font-family: 'Open Sans', sans-serif;
  color: #333;
`;

const FormInput = styled.input`
  width: 100%;
  padding: 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 16px;
  font-family: 'Open Sans', sans-serif;
  transition: all 0.3s ease;

  &:focus {
    outline: none;
    border-color: #4CAF50;
    box-shadow: 0 0 0 2px rgba(76, 175, 80, 0.2);
  }
`;

const FormTextarea = styled.textarea`
  width: 100%;
  padding: 12px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 16px;
  font-family: 'Open Sans', sans-serif;
  min-height: 150px;
  resize: vertical;
  transition: all 0.3s ease;

  &:focus {
    outline: none;
    border-color: #4CAF50;
    box-shadow: 0 0 0 2px rgba(76, 175, 80, 0.2);
  }
`;

const FormButton = styled(motion.button)`
  background: #4CAF50;
  color: #fff;
  padding: 12px 30px;
  border: none;
  border-radius: 4px;
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.3s ease;
  font-family: 'Open Sans', sans-serif;

  &:hover {
    background: #1A365D;
  }
`;

const TopLine = styled(motion.p)`
  color: #4CAF50;
  font-size: 16px;
  line-height: 16px;
  font-weight: 700;
  letter-spacing: 1.4px;
  text-transform: uppercase;
  margin-bottom: 16px;
  font-family: 'Open Sans', sans-serif;
`;

const Contact = () => {
  return (
    <ContactContainer id="contact">
      <ContactWrapper>
        <ContactInfo>
          <TopLine
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            Nossos Contatos
          </TopLine>
          <ContactTitle>Crematório Dom José</ContactTitle>
          <ContactSubtitle>
            Para informações acerca do Memorial Crematório e Cemitério Dom José entre em contato através dos meios abaixo:
          </ContactSubtitle>

          <ContactItem>
            <ContactIcon>
              <FaMapMarkerAlt />
            </ContactIcon>
            <ContactText as="a"
              href="https://www.google.com/maps/place/Cremat%C3%B3rio+Dom+Jos%C3%A9/data=!4m2!3m1!1s0x94f9344a8d140811%3A0xddfc28438ca78221?sa=X&ved=1t:2428&ictx=111"
              target="_blank"
              rel="noopener noreferrer"
            >
              ERS 162, N 2191, Bairro Auxiliadora - Santa Rosa - RS
            </ContactText>
          </ContactItem>

          <ContactItem>
            <ContactIcon>
              <FaEnvelope />
            </ContactIcon>
            <ContactText as="a"
              href="mailto:crematorio@crematoriodomjose.com.br"
            >
              crematorio@crematoriodomjose.com.br
            </ContactText>
          </ContactItem>

          <Row>
            <ContactItem>
              <ContactIcon style={{ rotate: '90deg' }}>
                <FaPhone />
              </ContactIcon>
              <ContactText as="a"
                href="tel:+5535122727"
              >
                (55) 3512 2727
              </ContactText>
            </ContactItem>
            <ContactItem style={{ marginLeft: 15 }}>
              <ContactIcon>
                <FaWhatsapp />
              </ContactIcon>
              <ContactText as="a"
                href="https://wa.me/555535122727"
              >
                (55) 3512 2727
              </ContactText>
            </ContactItem>
          </Row>

        </ContactInfo>
        <MapContainer>
          <a
            href="https://www.google.com/maps/place/Cremat%C3%B3rio+Dom+Jos%C3%A9/data=!4m2!3m1!1s0x0:0xddfc28438ca78221?sa=X&ved=1t:2428&ictx=111"
            target="_blank"
            rel="noopener noreferrer"
            style={{ display: 'block', width: '100%', height: '100%' }}
            aria-label="Abrir localização no Google Maps"
          >
            <iframe
              title="Mapa Crematório Dom José"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3526.4103994976967!2d-54.496283299999995!3d-27.8893766!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x94f9344a8d140811%3A0xddfc28438ca78221!2zQ3JlbWF0w7NyaW8gRG9tIEpvc8Op!5e0!3m2!1spt-BR!2sbr!4v1750517418633!5m2!1spt-BR!2sbr"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </a>
        </MapContainer>
      </ContactWrapper>

      <br /><br /><br />

      <ContactWrapper>
        <ContactInfo>
          <ContactTitle>Funerária São José</ContactTitle>
          <ContactSubtitle>
            Para informações acerca dos serviços funerários entre em contato através dos meios abaixo:
          </ContactSubtitle>

          <ContactItem>
            <ContactIcon>
              <FaMapMarkerAlt />
            </ContactIcon>
            <ContactText as="a"
              href="https://www.google.com/maps/place/Funeraria+S%C3%A3o+Jos%C3%A9/data=!4m2!3m1!1s0x0:0xb093a284095b7c5d?sa=X&ved=1t:2428&ictx=111"
              target="_blank"
              rel="noopener noreferrer"
            >
              R. Fernando Ferrari 591, Centro, Santa Rosa - RS
            </ContactText>
          </ContactItem>

          <ContactItem>
            <ContactIcon>
              <FaEnvelope />
            </ContactIcon>
            <ContactText as="a"
              href="mailto:crematorio@crematoriodomjose.com.br"
            >
              crematorio@crematoriodomjose.com.br
            </ContactText>
          </ContactItem>

          <Row>
            <ContactItem>
              <ContactIcon style={{ rotate: '90deg' }}>
                <FaPhone />
              </ContactIcon>
              <ContactText as="a"
                href="tel:+5535121297"
              >
                (55) 3512 1297
              </ContactText>
            </ContactItem>
            <ContactItem style={{ marginLeft: 15 }}>
              <ContactIcon>
                <FaWhatsapp />
              </ContactIcon>
              <ContactText as="a"
                href="https://wa.me/555535121297"
              >
                (55) 3512 1297
              </ContactText>
            </ContactItem>
          </Row>

        </ContactInfo>
        <MapContainer>
          <a
            href="https://www.google.com/maps/place/Funeraria+S%C3%A3o+Jos%C3%A9/data=!4m2!3m1!1s0x0:0xb093a284095b7c5d?sa=X&ved=1t:2428&ictx=111"
            target="_blank"
            rel="noopener noreferrer"
            style={{ display: 'block', width: '100%', height: '100%' }}
            aria-label="Abrir localização no Google Maps"
          >
            <iframe
              title="Mapa Crematório Dom José"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3527.1586424186235!2d-54.485817703091634!3d-27.8663967!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x94f935e3653f7a7f%3A0xb093a284095b7c5d!2zRnVuZXJhcmlhIFPDo28gSm9zw6k!5e0!3m2!1spt-BR!2sbr!4v1751141006791!5m2!1spt-BR!2sbr"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </a>
        </MapContainer>

        {/*<FormContainer
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <FormTitle>Envie uma Mensagem</FormTitle>
          <form>
            <FormGroup>
              <FormLabel>Nome</FormLabel>
              <FormInput type="text" placeholder="Seu nome completo" />
            </FormGroup>
            
            <FormGroup>
              <FormLabel>E-mail</FormLabel>
              <FormInput type="email" placeholder="Seu e-mail" />
            </FormGroup>
            
            <FormGroup>
              <FormLabel>Telefone</FormLabel>
              <FormInput type="tel" placeholder="Seu telefone" />
            </FormGroup>
            
            <FormGroup>
              <FormLabel>Mensagem</FormLabel>
              <FormTextarea placeholder="Digite sua mensagem aqui..." />
            </FormGroup>
            
            <FormButton
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              Enviar Mensagem
            </FormButton>
          </form>
        </FormContainer>*/}
      </ContactWrapper>

    </ContactContainer>
  );
};

export default Contact;
